import React, { useState } from "react";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

/**
 * ApplyConfirmStrip — Sub-sprint D-α.
 *
 * Second-click contract for `useDryRunApply.applyAction`. The operator
 * must type a literal confirm phrase (default "APPLY") before the
 * button enables. Disabled if `disabled` (e.g., no dry-run yet, stale,
 * kill-switch).
 */
export const ApplyConfirmStrip = ({
  disabled = false,
  disabledReason,
  onApply,
  confirmPhrase = "APPLY",
  applyLabel,
  dataTestId = "rl-apply-confirm-strip",
}) => {
  const t = useRacketLabAdminT();
  const [typed, setTyped] = useState("");
  const match = typed.trim() === confirmPhrase;
  const ready = !disabled && match;
  const finalApplyLabel = applyLabel != null && applyLabel !== "" ? applyLabel : t("common.actions.apply");

  return (
    <div data-testid={dataTestId} className="flex flex-col gap-2 rounded-md border border-amber-200 bg-amber-50 p-3">
      <p className="text-[11px] text-amber-900">
        {t("ops.apply_strip.type_to_enable", { phrase: confirmPhrase })}
        {disabled && disabledReason && (
          <span className="ml-1 font-medium text-rose-700">· {disabledReason}</span>
        )}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <input
          data-testid={`${dataTestId}-input`}
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          disabled={disabled}
          placeholder={confirmPhrase}
          className="flex-1 rounded-md border border-amber-300 bg-white px-2 py-1 font-mono text-xs"
        />
        <button
          type="button"
          data-testid={`${dataTestId}-button`}
          disabled={!ready}
          onClick={() => { if (ready) { onApply?.(); setTyped(""); } }}
          className={`rounded-md px-3 py-1.5 text-xs font-medium text-white ${ready ? "bg-rose-600 hover:bg-rose-700" : "bg-rose-300 cursor-not-allowed"}`}
        >
          {finalApplyLabel}
        </button>
      </div>
    </div>
  );
};

export default ApplyConfirmStrip;
